import { DeclinedReason } from '@quorum/models/xs-resource';
// eslint-disable-next-line max-len
import { DeclinedReasonQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export const GET_DECLINED_REASONS_FROM_SERVER = '[LABOUR OPERATIONS] Get Declined Reasons From Server';
export class GetDeclinedReasonsFromServer implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_DECLINED_REASONS_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: DeclinedReasonQueryParameters) {}
}

export const GET_DECLINED_REASONS_FROM_SERVER_SUCCESS = '[LABOUR OPERATIONS] Get Declined Reasons From Server Success';
export class GetDeclinedReasonsFromServerSuccess implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_DECLINED_REASONS_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  constructor(public payload: { declinedReason: DeclinedReason[] }) {}
}

export const GET_DECLINED_REASONS_FROM_SERVER_FAILURE = '[LABOUR OPERATIONS] Get Declined Reasons From Server Failure';
export class GetDeclinedReasonsFromServerFailure implements Action {
  readonly feature = 'labourOperations';
  readonly type = GET_DECLINED_REASONS_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type DeclinedReasonsAction =
  | GetDeclinedReasonsFromServer
  | GetDeclinedReasonsFromServerSuccess
  | GetDeclinedReasonsFromServerFailure;
